import { JSX, useEffect, useState } from 'react';
import { calendarService, CalendarEvent } from '../../services/calendarService';
import WindowBar from '../../common/windowBar/windowBar';
import CalendarIcon from '../../assets/images/icons/calendar.png';
import './eventPreview.css';
import rainbow from '../../assets/images/icons/rainbow.png';
import taiwan from '../../assets/images/icons/taiwan.png';
import usa from '../../assets/images/icons/burger.png';
import tobacco from '../../assets/images/icons/tobacco.png';
import clock from '../../assets/images/icons/clock.png';
import hyte from '../../assets/images/icons/packaging.png';

const EventPreview = ({ setLoading }: { setLoading: (loading: boolean) => void }): JSX.Element => {
    const [events, setEvents] = useState<CalendarEvent[]>([]);
    const [displayEvents, setDisplayEvents] = useState<CalendarEvent>();
    const [countdown, setCountdown] = useState<number>(0);

    const formatCountdown = (ms: number): string => {
        const hours = Math.floor(ms / (1000 * 60 * 60));
        const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
        
        if (hours === 0) {
            return `${minutes} min`;
        }
        return `in ${hours} hr and ${minutes} min`;
    };

    const refreshEvents = async (isFirstLoad = false) => {
        if (isFirstLoad) 
            setLoading(true);
        const events = await calendarService.getEvents();
        setEvents(events);
        if (isFirstLoad) 
            setLoading(false);
    }

    useEffect(() => {
        refreshEvents(true);
    }, []);

    useEffect(() => {
        const today = new Date();
        const todayString = today.toISOString();
        
        // Find the next upcoming event
        const upcomingEvent = events.find(event => 
            (event.start.dateTime || event.start.date) >= todayString 
        );
        
        if (upcomingEvent) {
            setDisplayEvents(upcomingEvent);
            console.log("set upcoming event");
        }
    }, [events]);

    useEffect(() => {
        if (displayEvents) {

            const updateCountdown = () => {
                const eventDate = new Date(displayEvents.start.dateTime || displayEvents.start.date);
                const now = new Date();
                const timeDiff = eventDate.getTime() - now.getTime();
                setCountdown(timeDiff);

                if(timeDiff <= 0)
                    refreshEvents();
            };
            // Update immediately
            updateCountdown();

            // Set up interval to update every minute
            const intervalId = setInterval(updateCountdown, 60000);

            // Clean up interval on unmount
            return () => clearInterval(intervalId);
        }
    }, [displayEvents]);

    const getEventDate = () : string =>  {
        const eventDate = new Date(displayEvents.start.dateTime || displayEvents.start.date);
        const month = eventDate.toLocaleString('default', { month: 'short' });
        const date = eventDate.getDate();
        return `${month} ${date}`;
    }

    const getEventTime = () : string =>  {
        if (displayEvents.start.date != null)
            return 'All Day';
        else {
            const eventDate = new Date(displayEvents.start.dateTime);
            const hour = eventDate.getHours() % 12 || 12;
            const min = eventDate.getMinutes().toString().padStart(2, '0');
            const startAmPm = eventDate.getHours() >= 12 ? 'PM' : 'AM';

            if (min === '00')
                return `${hour} ${startAmPm}`
            else
                return `${hour}:${min} ${startAmPm}`
        }
    }

    const getCalendarIcon = () : string => {
        if (displayEvents.calendarId === 'primary') { return rainbow; }
        if (displayEvents.calendarId === 'taiwan holiday') { return taiwan; }
        if (displayEvents.calendarId === 'us holiday') { return usa; }
        if (displayEvents.calendarId === 'work') { return tobacco; }
        if (displayEvents.calendarId === 'HYTE') { return hyte; }
        return '../../assets/icons/rainbow.png';
    }
    
    return (
        <div className='todo-preview-outter-container outter-container'>
            <div className='pixel-container-back'/>
            <div className='pixel-container-top'>
                <div className='pixel-container-border'>
                    <WindowBar IconSrc={CalendarIcon} title={formatCountdown(countdown)} onClick={()=>{}}/>
                    <div className='main-pixel-container preview-event-container'>
                        <p className='event-preview-date'>{displayEvents? getEventDate() : ""}</p>
                        <img className='event-preview-icon' src={clock}/>
                        <p className='event-preview-date'>{displayEvents? getEventTime() : ""}</p>
                        {displayEvents && <img className='event-preview-icon' src={getCalendarIcon()}/>}
                        <p className='event-preview-summary'>{displayEvents?.summary}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EventPreview;
